import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const root = css`
  max-width: ${styles.width.modal.compact};
  padding: ${styles.size[56]} ${styles.size[24]};
  text-align: center;

  ${styles.breakpoint.up('sm')} {
    padding: ${styles.size[64]} ${styles.size[32]};
  }
`
